const normalizeLabel = (value: string = '') => value.trim().toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
export const daysOf = (value: string = '') => Array.from(new Set(value.split('-').map(normalizeLabel).filter(Boolean))).sort();

export const countItems = (items: Product[], rol: string) => {
  const counters = { back: { upper: 0, lower: 0, other: 0, otherClothe: 0 }, front: { LUNES: 0, MARTES: 0, MIERCOLES: 0, JUEVES: 0, VIERNES: 0 } };
  for (const item of items) {
    const segment = normalizeLabel(item.segmento_Prenda);
    const combined = ['VESTIDO', 'TRAJE', 'ENTERIZO'].includes(segment);
    if (segment === 'SUPERIOR' || combined) counters.back.upper++;
    if (segment === 'INFERIOR' || combined) counters.back.lower++;
    if (segment === 'CHAQUETA') counters.back.other++;
    if (['SACO', 'SUETER'].includes(segment)) counters.back.other += 0.5;
    if (combined) counters.back.otherClothe++;
    if (rol === 'FRONT') for (const day of daysOf(item.dias || item.dia)) {
      if (day in counters.front) counters.front[day as keyof typeof counters.front] += combined ? 2 : 1;
    }
  }
  return counters;
};

export function readCart(data: any) {
  if (!data || !Array.isArray(data.carrito) || !['creado', 'pendiente', 'enviado'].includes(data.estado)) {
    throw new Error('El servidor devolvió un carrito que no se puede verificar. Intenta nuevamente.');
  }
  const items: Product[] = data.carrito.map((row: any) => {
    if (!row.prenda || row.prenda.id == null || row.id_prenda == null) throw new Error('El servidor devolvió una selección sin identificador. No se envió el pedido.');
    return { ...row.prenda, talla: row.talla, id_prenda: row.id_prenda, id_carrito: row.id_carrito,
      segmento_Prenda: normalizeLabel(row.prenda.segmento_Prenda || row.segmento_Prenda || ''),
      dias: daysOf(row.dia || row.dias || row.prenda.dias || row.prenda.dia || '').join('-'),
      id_order: String(row.id_order ?? row.prenda.id_order ?? '') };
  });
  return { items, id: String(data.carrito_id ?? ''), status: data.estado as 'creado' | 'pendiente' | 'enviado' };
}

export function validateOrder(items: Product[], local: Product[], rol: string, admin: boolean, limits: number[], validateOutfits = true) {
  const seen = new Set<string>();
  const outfits = new Map<string, string>();
  for (const item of items) {
    const id = String(item.id);
    if (seen.has(id)) return `La prenda ${id} está repetida en el backend. Debes corregir el carrito antes de enviar.`;
    seen.add(id);
    if (!item.talla?.trim()) return `La prenda ${id} no tiene talla.`;
    if (item.tallas && !item.tallas.split('-').includes(item.talla)) return `La talla de la prenda ${id} no es válida.`;
    if (!['SUPERIOR', 'INFERIOR', 'CHAQUETA', 'SACO', 'SUETER', 'VESTIDO', 'TRAJE', 'ENTERIZO'].includes(item.segmento_Prenda)) return `No se pudo validar el tipo de la prenda ${id}.`;
    if (rol === 'FRONT' && validateOutfits) {
      const days = daysOf(item.dias);
      if (!item.id_order || !days.length) return 'El carrito no informa el outfit o sus días. No es posible verificar un outfit por día.';
      for (const day of days) {
        if (outfits.has(day) && outfits.get(day) !== item.id_order) return `Hay prendas de distintos outfits para ${day.toLowerCase()}.`;
        outfits.set(day, item.id_order);
      }
    }
  }
  if (!['FRONT', 'BACK'].includes(rol) || !limits.every(n => Number.isFinite(n) && n >= 0)) return 'No se pudieron verificar los límites del pedido.';
  const { upper, lower, other } = countItems(items, rol).back;
  const counts = [upper, lower, other, upper + lower + other];
  if (!counts.every((n, i) => admin ? n <= limits[i] : n === limits[i])) return 'El carrito del backend no cumple las cantidades permitidas para tu pedido.';
  const signature = (list: Product[]) => JSON.stringify(list.map(item => JSON.stringify([
    String(item.id), String(item.id_prenda), item.talla, ...(rol === 'FRONT' ? [daysOf(item.dias)] : [])
  ])).sort());
  if (signature(items) !== signature(local)) return 'Las prendas o tallas del backend no coinciden con el carrito mostrado.';
  return null;
}
